export default __webpack_public_path__ + "static/media/unsplash_1pAwJiCD60c.12c9dc76.jpg";